import React, { useEffect,useState } from "react";
import MenuProcessService from "../services/MenuProcessService";
import { toast } from 'react-toastify';
import { useLoading } from '../Utils/LoadingContext';
import showToast from "../Utils/ToastContainer";
import './TPLogin.css'
function TPLogin() {
const [users, setUsers] = useState([]);
const [editingId, setEditingId] = useState(null);
const { setLoading } = useLoading();
  const [form, setForm] = useState({
    userCode: "",
    password: "",
    companyCode: "",
    active: true,
    createdBy: "admin"
  });

  const getUsers = async() => {
    try {
    const response = await MenuProcessService.getTPLogin();
    setUsers(response.data.result)
    } catch (err) {
      console.error(err);
      //alert("Failed to load menus");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };
const handleEdit = (user) => {
  setForm({
    id:user.id,
    userCode: user.userCode,
    password: user.password,
    companyCode: user.companyCode,
    active: user.active,
    createdBy: user.createdBy
  });
  setEditingId(user.id);
};
  const handleSubmit = async () => {
    if (!form.userCode.trim()) {
    toast.error("User Code is required");
    return;
  }
  if (!form.password.trim()) {
    toast.error("Password is required");
    return;
  }
  if (!form.companyCode.trim()) {
    toast.error("Company Code is required");
    return;
  }
  try {
    debugger;
    setLoading(true);
    let response;
    if (editingId) {
      response = await MenuProcessService.updateTPLogin(form);
    } else {
      response = await MenuProcessService.setTPLogin(form);
    }

    if (response.data.statusCode === 200) {
      showToast(editingId ? "User updated successfully." : "User inserted successfully.", 'success', { autoClose: 1500 });
      getUsers();
      setForm({ userCode: "", password: "", companyCode: "", active: true, createdBy: localStorage.getItem('empcode') });
      setEditingId(null);
    } else {
      toast.error("Please try again.");
    }
  } catch (error) {
    toast.error("An error occurred.");
    console.error(error);
  } finally {
    setLoading(false);
  }
};
    return (
  <div className="user-form">
  <h5>Third Party Entery</h5>
  <form className="horizontal-form">
  <div className="form-group">
    <label>User Code</label>
    <input name="userCode" value={form.userCode} onChange={handleChange} />
  </div>
  <div className="form-group">
    <label>Password</label>
    <input name="password" value={form.password} onChange={handleChange} />
  </div>
  <div className="form-group">
    <label>Company Code</label>
    <input name="companyCode" value={form.companyCode} onChange={handleChange} />
  </div>
  <div className="form-group checkbox-group">
    <label>
      <input name="active" type="checkbox" checked={form.active} onChange={handleChange} />
      Active
    </label>
  </div>
  <div className="form-group">
    <button type="button" onClick={handleSubmit}>
      {editingId ? "Update" : "Submit"}
    </button>
  </div>
</form>

  <h5>All Users</h5>
  <div className="table-wrapper">
  <table className="user-table">
    <thead>
      <tr>
        <th>ID</th><th>UserCode</th><th>Password</th><th>CompanyCode</th><th>Active</th><th>CreatedBy</th><th>CreatedOn</th><th>Action</th>
      </tr>
    </thead>
    <tbody>
      {users.map(u => (
        <tr key={u.id}>
          <td>{u.id}</td>
          <td>{u.userCode}</td>
          <td>{u.password}</td>
          <td>{u.companyCode}</td>
          <td>{u.active ? "Yes" : "No"}</td>
          <td>{u.createdBy}</td>
          <td>{new Date(u.createdOn).toLocaleString()}</td>
          <td><button onClick={() => handleEdit(u)}>Edit</button></td>
        </tr>
      ))}
    </tbody>
  </table>
</div>
</div>
);
}

export default TPLogin